var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96698 6.954H23.999V0.695C24.006 0.51853 23.943 0.346429 23.8237 0.216232C23.7044 0.0860353 23.5384 0.0083066 23.362 0H9.96198L9.96698 6.954ZM0 14.086H6.954V9.914H0V14.086ZM0.205008 23.795C0.0749525 23.6649 0.0013091 23.4889 0 23.305V17.046H6.954V24H0.695C0.511079 23.9987 0.335063 23.925 0.205008 23.795ZM9.96698 17.046V24H23.367C23.5435 23.9919 23.7096 23.9143 23.829 23.784C23.9484 23.6538 24.0113 23.4815 24.004 23.305V17.046H9.96698ZM9.96698 9.914V14.086H23.999V9.914H9.96698ZM0.695 0H6.954V6.954H0V0.695C0.0013091 0.511079 0.0749525 0.335063 0.205008 0.205008C0.335063 0.0749525 0.511079 0.0013091 0.695 0Z",
    fill: "#BABEC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatics);
export default __webpack_public_path__ + "static/media/statics.8c115de875572aa07b5b45d889bb7f30.svg";
export { ForwardRef as ReactComponent };